import { lazy, Suspense } from 'react';
import { Route, Routes as RouterRoutes } from 'react-router-dom';
import ContractPreview from '../_pages/contract-preview/index.tsx';

const ContractAnalysis = lazy(() => import('../_pages/contract-analysis/index.tsx'));
const ContractAnalysisResults = lazy(() => import('../_pages/results/index.tsx'));
const AuthenticatedLayout = lazy(() => import('../layouts/AuthenticatedLayout.tsx'));

const LoadingFallback = () => (
  <div className="flex items-center justify-center min-h-screen">Loading...</div>
);

export const Routes = () => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <RouterRoutes>
        {/* Rotas públicas */}
        {/* <Route path="/login" element={<Login />} />
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} /> */}

        <Route path="/contract-analysis/preview" element={<ContractPreview />} />
        <Route path="/" element={<ContractAnalysis />} />
        {/* Rotas autenticadas */}
        <Route element={<AuthenticatedLayout />}>
          <Route path="/contract-analysis/results" element={<ContractAnalysisResults />} />
          {/* Adicione outras rotas protegidas aqui */}
        </Route>
      </RouterRoutes>
    </Suspense>
  );
};
